import React from 'react';
import TextField from 'material-ui/TextField';

const renderTextField = ({input, label, value, meta: {touched, error}, children, select, type}) => (
    <div>
        <TextField
            className='material-form__field'
            label={label}
            error={touched && error != null}
            value={input.value}
            children={children}
            select={select}
            type={type}
            autoComplete='off'
            onChange={(e) => {
                e.preventDefault();
                input.onChange(e.target.value);
            }}
        >
        </TextField>
        {touched && error && <span className='material-form-group-error'>{error}</span>}
    </div>
);

export default renderTextField;



// WEBPACK FOOTER //
// ./src/theme/components/form/Input.js